// frontend/app/quizStyles.js

import { StyleSheet } from "react-native";

export default function quizStyles(isDarkMode) {
  return StyleSheet.create({
    quizCardContainer: {
      marginVertical: 15,
      padding: 20,
      borderRadius: 12,
      backgroundColor: isDarkMode ? "#252525" : "#FFF",
      shadowColor: "#000",
      shadowOpacity: 0.08,
      shadowRadius: 6,
      elevation: 4,
    },
    quizQuestion: {
      fontSize: 18,
      fontWeight: "bold",
      marginBottom: 10,
      color: isDarkMode ? "#FFF" : "#222",
    },
    quizOption: {
      padding: 12,
      marginVertical: 6,
      borderRadius: 8,
      backgroundColor: isDarkMode ? "#333" : "#F8F9FA",
      borderWidth: 1,
      borderColor: isDarkMode ? "#555" : "#ddd",
    },
    optionText: {
      fontSize: 16,
      fontWeight: "500",
      color: isDarkMode ? "#FFF" : "#222",
    },
    correctAnswer: {
      backgroundColor: "#D4EDDA",
      borderColor: "#28A745",
    },
    wrongAnswer: {
      backgroundColor: "#F8D7DA",
      borderColor: "#DC3545",
    },
    inputField: {
      // pull from your `inputField` style if you have one;
      // if not explicitly defined yet, we can base this on what you're using
      // in QuestionDisplay TextInput today:
      borderWidth: 1,
      borderColor: "#ccc",
      backgroundColor: isDarkMode ? "#1e1e1e" : "#fff",
      borderRadius: 6,
      padding: 10,
      color: isDarkMode ? "#fff" : "#000",
      marginTop: 8,
    },

    hintButton: {
      marginTop: 10,
      padding: 10,
      borderRadius: 8,
      backgroundColor: "#6B7280", // neutral gray button
      alignItems: "center",
    },
    hintText: {
      color: "#fff",
      fontSize: 14,
      lineHeight: 18,
    },

    solutionButton: {
      marginTop: 10,
      padding: 10,
      borderRadius: 8,
      backgroundColor: "#007BFF",
      alignItems: "center",
    },
    solutionButtonText: {
      color: "white",
      fontWeight: "bold",
      fontSize: 16,
    },
    solutionText: {
      marginTop: 10,
      padding: 10,
      borderRadius: 8,
      backgroundColor: "#FFF3CD",
      borderColor: "#FFC107",
      borderWidth: 1,
      fontSize: 16,
      color: "#000",
    },
    sectionTitle: {
      fontSize: 15,
      fontWeight: "600",
      color: isDarkMode ? "#fff" : "#333",
      marginBottom: 4,
    },

    // ── Question Navigator Grid ──
    navigatorContainer: {
      flexDirection: "row",
      flexWrap: "wrap",
      gap: 8,
      padding: 12,
      marginBottom: 12,
      backgroundColor: isDarkMode ? "#1e293b" : "#f8fafc",
      borderRadius: 10,
      borderWidth: 1,
      borderColor: isDarkMode ? "#334155" : "#e2e8f0",
    },
    navigatorCircle: {
      width: 36,
      height: 36,
      borderRadius: 18,
      borderWidth: 2,
      borderColor: isDarkMode ? "#475569" : "#d1d5db",
      backgroundColor: "transparent",
      alignItems: "center",
      justifyContent: "center",
    },
    navigatorCircleCurrent: {
      borderColor: isDarkMode ? "#818cf8" : "#6366f1",
      borderWidth: 3,
    },
    navigatorCircleAnswered: {
      backgroundColor: isDarkMode ? "#60a5fa" : "#3b82f6",
      borderColor: isDarkMode ? "#60a5fa" : "#3b82f6",
    },
    navigatorCircleCorrect: {
      backgroundColor: isDarkMode ? "#34d399" : "#10B981",
      borderColor: isDarkMode ? "#34d399" : "#10B981",
    },
    navigatorCircleWrong: {
      backgroundColor: isDarkMode ? "#f87171" : "#DC3545",
      borderColor: isDarkMode ? "#f87171" : "#DC3545",
    },
    navigatorCircleText: {
      fontSize: 13,
      fontWeight: "600",
      color: isDarkMode ? "#cbd5e1" : "#4b5563",
    },
    navigatorCircleTextCurrent: {
      color: isDarkMode ? "#818cf8" : "#6366f1",
      fontWeight: "700",
    },
    navigatorCircleTextAnswered: {
      color: "#fff",
      fontWeight: "700",
    },

    // ── Progress text ──
    progressText: {
      fontSize: 14,
      fontWeight: "600",
      color: isDarkMode ? "#94a3b8" : "#6b7280",
      textAlign: "center",
      marginBottom: 8,
    },

    // ── Previous / Next buttons ──
    paginationNav: {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      marginTop: 16,
      paddingTop: 12,
    },
    paginationButton: {
      flexDirection: "row",
      alignItems: "center",
      paddingVertical: 10,
      paddingHorizontal: 18,
      borderRadius: 8,
      borderWidth: 1.5,
      borderColor: isDarkMode ? "#6366f1" : "#4f46e5",
      backgroundColor: isDarkMode ? "rgba(99,102,241,0.1)" : "rgba(79,70,229,0.05)",
    },
    paginationButtonDisabled: {
      borderColor: isDarkMode ? "#334155" : "#d1d5db",
      backgroundColor: "transparent",
      opacity: 0.5,
    },
    paginationButtonText: {
      fontSize: 15,
      fontWeight: "600",
      color: isDarkMode ? "#818cf8" : "#4f46e5",
    },
    paginationButtonTextDisabled: {
      color: isDarkMode ? "#475569" : "#9ca3af",
    },

    // ── AIT-249: Review screen (deferred-feedback) ───────────────────────
    reviewSummaryCard: {
      marginBottom: 16,
      padding: 18,
      borderRadius: 14,
      backgroundColor: isDarkMode ? "#1e293b" : "#ffffff",
      borderWidth: 1,
      borderColor: isDarkMode ? "#334155" : "#e2e8f0",
      shadowColor: "#000",
      shadowOpacity: 0.06,
      shadowRadius: 6,
      elevation: 2,
      alignItems: "center",
    },
    reviewSummaryTitle: {
      fontSize: 13,
      fontWeight: "700",
      letterSpacing: 0.8,
      textTransform: "uppercase",
      color: isDarkMode ? "#94a3b8" : "#64748b",
      marginBottom: 6,
    },
    reviewSummaryScore: {
      fontSize: 28,
      fontWeight: "800",
      color: isDarkMode ? "#f1f5f9" : "#1e293b",
      marginBottom: 12,
    },
    reviewSummaryChipsRow: {
      flexDirection: "row",
      flexWrap: "wrap",
      gap: 8,
      justifyContent: "center",
    },
    reviewSummaryChip: {
      paddingHorizontal: 10,
      paddingVertical: 5,
      borderRadius: 999,
      borderWidth: 1,
    },
    reviewSummaryChipCorrect: {
      backgroundColor: isDarkMode ? "rgba(52,211,153,0.15)" : "#ecfdf5",
      borderColor: isDarkMode ? "#34d399" : "#10b981",
    },
    reviewSummaryChipWrong: {
      backgroundColor: isDarkMode ? "rgba(248,113,113,0.15)" : "#fef2f2",
      borderColor: isDarkMode ? "#f87171" : "#dc2626",
    },
    reviewSummaryChipSkipped: {
      backgroundColor: isDarkMode ? "rgba(148,163,184,0.15)" : "#f1f5f9",
      borderColor: isDarkMode ? "#94a3b8" : "#94a3b8",
    },
    reviewSummaryChipText: {
      fontSize: 12,
      fontWeight: "600",
      color: isDarkMode ? "#f1f5f9" : "#1e293b",
    },

    reviewBlock: {
      marginTop: 14,
      padding: 12,
      borderRadius: 10,
      backgroundColor: isDarkMode ? "#0f172a" : "#f8fafc",
      borderWidth: 1,
      borderColor: isDarkMode ? "#334155" : "#e2e8f0",
    },
    reviewBadge: {
      alignSelf: "flex-start",
      paddingHorizontal: 10,
      paddingVertical: 4,
      borderRadius: 999,
      marginBottom: 8,
    },
    reviewBadgeCorrect: {
      backgroundColor: isDarkMode ? "rgba(52,211,153,0.2)" : "#d1fae5",
    },
    reviewBadgeWrong: {
      backgroundColor: isDarkMode ? "rgba(248,113,113,0.2)" : "#fee2e2",
    },
    reviewBadgeSkipped: {
      backgroundColor: isDarkMode ? "rgba(148,163,184,0.2)" : "#e2e8f0",
    },
    reviewBadgeText: {
      fontSize: 12,
      fontWeight: "700",
      color: isDarkMode ? "#f1f5f9" : "#1e293b",
    },

    correctAnswerCallout: {
      marginBottom: 10,
      padding: 10,
      borderRadius: 8,
      backgroundColor: isDarkMode ? "rgba(52,211,153,0.1)" : "#ecfdf5",
      borderLeftWidth: 3,
      borderLeftColor: isDarkMode ? "#34d399" : "#10b981",
    },
    correctAnswerCalloutLabel: {
      fontSize: 11,
      fontWeight: "700",
      letterSpacing: 0.6,
      textTransform: "uppercase",
      color: isDarkMode ? "#34d399" : "#047857",
      marginBottom: 4,
    },
    correctAnswerCalloutText: {
      fontSize: 15,
      fontWeight: "600",
      color: isDarkMode ? "#f1f5f9" : "#064e3b",
    },

    reviewExplanationBlock: {
      marginTop: 4,
      padding: 10,
      borderRadius: 8,
      backgroundColor: isDarkMode ? "#1e293b" : "#fffbeb",
      borderLeftWidth: 3,
      borderLeftColor: isDarkMode ? "#fbbf24" : "#f59e0b",
    },
    reviewExplanationLabel: {
      fontSize: 11,
      fontWeight: "700",
      letterSpacing: 0.6,
      textTransform: "uppercase",
      color: isDarkMode ? "#fbbf24" : "#92400e",
      marginBottom: 4,
    },
    reviewExplanationText: {
      fontSize: 14,
      color: isDarkMode ? "#f1f5f9" : "#1e293b",
      lineHeight: 20,
    },

    // Card-level review accent (optional border on the question card).
    reviewCardCorrect: {
      borderLeftWidth: 4,
      borderLeftColor: isDarkMode ? "#34d399" : "#10b981",
    },
    reviewCardWrong: {
      borderLeftWidth: 4,
      borderLeftColor: isDarkMode ? "#f87171" : "#dc2626",
    },
  });
}
